import { Document, Page, pdf, Text, View } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import moment from "moment"
import { RowExportTypePdf } from "types"
import { StatusEnum } from "../.."
import { DataList } from "../../types"

type UseExportPdf = {
  data: DataList[]
}

export const useExportPdf = ({ data }: UseExportPdf) => {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "DATE", key: "date", width: 15 },
    { header: "FILENAME", key: "filename", width: 25 },
    { header: "DESCRIPTION", key: "description", width: 15 },
    { header: "STATUS", key: "status", width: 15 }
  ]

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      date: moment(item.transaction_date).format("DD/MM/YYYY"),
      filename: item.file_name,
      description: item.file_description ?? "",
      status: Number(item.status) === StatusEnum.Review ? "Review" : "Submit"
    }
  })

  return {
    handleExportPdf: () =>
      pdf(<PdfTemplate data={dataMap} column={columns} />)
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = `product-import.pdf`
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  column
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>PRODUCT IMPORT</Text>
        <TableCell data={data} column={column} />
        <View
          style={{
            marginTop: 10,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}
        />
      </Page>
    </Document>
  )
}
